import React from "react";
import { useNavigate } from "react-router-dom";
import Grid from "@mui/material/Unstable_Grid2";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import {
  Link,
  Box,
  Button,
  Tooltip,
  Switch,
  TextField,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import RKTextField from "../../../../Supporting files/RKTextField/RKTextField";
import SearchDropdown from "../../../../Supporting files/SearchDropdown/SearchDropdown";
import SelectDropdown from "../../../../Supporting files/SelectDropdown/SelectDropdown";
import "./BulkUpload.scss";
import { ALL_ROUTES } from "../../../../Routes/all_routes";

function BulkUploadPage() {
  const navigate = useNavigate();
  const [show, setShow] = React.useState(false);
  const [findDuplicates, setFindDuplicates] = React.useState("None");
  const [dateTimeFormat, setDateTimeFormat] = React.useState("None");

  const findDuplicates_data = [
    { key: "None", value: "None" },
    { key: "Semiconductor Equipment", value: "Semiconductor Equipment" },
    { key: "Hardware Technology", value: "Hardware Technology" },
  ];
  const dateTimeFormat_data = [
    { key: "format1", value: "11/12/2022 (MM/DD/YYYY)" },
    { key: "format2", value: "11/12/2022 (MM/DD/YYYY)" },
    { key: "format3", value: "11/12/2022 (MM/DD/YYYY)" },
    { key: "format3", value: "11/12/2022 (MM/DD/YYYY)" },
  ];

  const updateMasterState = (attrName: any, value: any) => {
    attrName(value);
  };
  return (
    <Box className="BulklayoutWrapper">
      {/* Page header */}
      <Grid container spacing={3} className="pageHeader">
        <Grid xs={6} className="pageTitle">
          <Link
            className="backStep"

            onClick={() => {
              navigate(-1);
            }}>
            <ChevronLeftIcon />
          </Link>

          <div>
            <h3> Import from Spreadsheet</h3>
          </div>
        </Grid>
      </Grid>

      <Grid container spacing={3}>
        <Grid xs={12} className="innerSection pl-10 pr-10">
          <Grid container spacing={3}>
            <Grid xs={7} className="leftPart">
              <Grid container>
                <Grid xs={12} marginBottom="10px">
                  <p>Select a file to upload</p>
                  <Grid container>
                    <Grid xs={5} className="inputField uploadFile" padding={0}>
                      <TextField
                        fullWidth
                        id="outlined-basic"
                        label="Upload document"
                        variant="outlined"
                        className="textarea"
                      />
                    </Grid>
                    <Grid xs={2} padding={0}>
                      <Button
                        variant="contained"
                        className="browsebtn"
                        component="label">
                        Browse
                        <input hidden accept="image/*" multiple type="file" />
                      </Button>
                    </Grid>
                  </Grid>
                  <p className="fileUploadTypeDetails">
                    Files may be upto 50 MB, and .xls, .xlsx, .csv or .vcf
                    formats
                  </p>
                </Grid>
                <Grid xs={12} marginBottom="10px">
                  <p>In case of duplicate records found</p>
                  <RadioGroup defaultValue="Skip">
                    <FormControlLabel
                      value="Skip"
                      control={<Radio />}
                      label="Skip"
                    />
                    <FormControlLabel
                      value="Overwrite"
                      control={<Radio />}
                      label="Overwrite"
                    />
                    <FormControlLabel
                      value="Clone"
                      control={<Radio />}
                      label="Clone"
                    />
                  </RadioGroup>
                </Grid>
                <Grid xs={12}>
                  {/* <a href="" className='advanced_option_link' onClick={() => setShow(!show)}>Advanced Options</a> */}
                  <Link
                    className="advanced_option_link"
                    onClick={() => setShow(!show)}>
                    Advanced Options
                  </Link>
                </Grid>
                {show && (
                  <Grid xs={12}>
                    <Grid container padding={0} marginBottom="10px">
                      <Grid xs={6}>
                        <SelectDropdown
                          class_name="inputField"
                          title="Find Duplicates Using"
                          value={findDuplicates}
                          attrName={setFindDuplicates}
                          value_update={updateMasterState}
                          dropdown_data={findDuplicates_data}
                          warn_status={false}
                        />
                      </Grid>
                    </Grid>
                    <Grid container padding={0} marginBottom="10px">
                      <Grid xs={6}>
                        <SelectDropdown
                          class_name="inputField"
                          title="Date/Time format of uploaded file"
                          value={dateTimeFormat}
                          attrName={setDateTimeFormat}
                          value_update={updateMasterState}
                          dropdown_data={dateTimeFormat_data}
                          warn_status={false}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                )}
                <Grid xs={12} className="ctaBtn">
                  <Button
                    variant="contained"
                    className="submitBtn"
                    onClick={() => {
                      navigate(ALL_ROUTES.MAP_FIELDS);
                    }}>
                    Continue
                  </Button>
                </Grid>
              </Grid>
            </Grid>
            <Grid xs={5} className="rightPart">
              <Grid container>
                <Grid xs={12} className="innerPart">
                  <Grid container>
                    <Grid xs={12} padding="0">
                      <p>Supported Formats</p>
                      <ul>
                        <li>
                          You can use .xls .xlsx .vcf or .csv format and import
                          up to 1500 records. For more than 1500 records, only
                          .csv format is supported.
                        </li>
                      </ul>
                    </Grid>
                    <Grid xs={12} padding="0">
                      <p>Maximum limits</p>
                      <ul>
                        <li>Enterprise - 20000 per batch.</li>
                        <li>
                          Skip/Overwrite can be performed with a maximum of 5000
                          records.
                        </li>
                      </ul>
                    </Grid>
                    <Grid xs={12} padding="0">
                      <p>Important notes</p>
                      <ul>
                        <li>
                          Duplicates will be verified based on "Email" field.
                        </li>
                        <li>
                          First row of the given file will be treated as field
                          names.
                        </li>
                        <li>
                          Please ensure your file size does not exceed 50 MB.
                        </li>
                        <li>
                          Before importing the data all duplicate records will
                          be ignored from the XLS/CSV file.
                        </li>
                        <li>
                          While checking for duplicate records, you can
                          overwrite, clone, or skip the duplicates.
                        </li>
                        <li>
                          In case of XLS file, only MS Excel 97 - 2003 formats
                          are supported.
                        </li>
                        <li>
                          Unexpected errors may occur if the XLS file contains
                          any special controls like combo filters or images
                          embedded within it.
                        </li>
                        <li>
                          Please ensure your file size does not exceed 50 MB.
                        </li>
                        <li>
                          If you have "File/image Upload" fields in the form,
                          please follow the steps below: For example, say you
                          have "Attach Documents" field
                          <ul className="sublist">
                            <li>
                              In your XLS or CSV file, create a separate column
                              for "Attach Resume" field and name it as
                              "Attachment" (user defined).
                            </li>
                            <li>
                              Under the column "Attachment" enter the file
                              names.
                            </li>
                            <li>
                              All files under the "Attachment" should be created
                              as a single Zip file.
                            </li>
                            <li>
                              Browse the Zip file in the second page of the
                              Import wizard (Details Mapping).{" "}
                            </li>
                            <li>
                              Attachment zip should not have any directory
                              structure.
                            </li>
                            <li>
                              Repeat the above steps for each "File/image"
                              upload field.
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}

export default BulkUploadPage;
